import { render, staticRenderFns } from "./IntroducingWellnessActivities.vue?vue&type=template&id=22c7d741&scoped=true&"
import script from "./IntroducingWellnessActivities.vue?vue&type=script&lang=js&"
export * from "./IntroducingWellnessActivities.vue?vue&type=script&lang=js&"
import style0 from "./IntroducingWellnessActivities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7d741",
  null
  
)

export default component.exports